<template>
    <VDropdown
        no-auto-focus
        v-bind="$attrs"
        placement="bottom"
        class="diary-dropdown-popper"
        :distance="distance"
        :skidding="0"
        :prevent-overflow="true"
        :overflow-padding="10"
        auto-boundary-max-size
        :theme="dropdowntheme"
        :positioning-disabled="isMobile"
        @apply-show="onShow()"
        @apply-hide="onHide()"
    >
        <div @click="(e) => e.stopPropagation()">
            <app-dropdown-btn
                ref="popperButton"
                :class="[gray ? 'dropdown_btn__gray' : 'dropdown_btn']"
                :classes="btnClass"
            >
                <slot name="dropdownBtn"></slot>
            </app-dropdown-btn>
        </div>
        <template #popper="{ hide }">
            <div
                data-v-0bd01313=""
                class="sm:hidden my-6 mx-auto w-12 h-[5px] bg-black-900 rounded-full"
            ></div>
            <slot name="content" v-bind="{ hide }" />
        </template>
    </VDropdown>
</template>

<script setup>
import { ref } from 'vue';
import AppDropdownBtn from './AppDropdownBtn.vue';
import { useScreenSize } from '@/composables/globals.js';

const isMobile = ref(false);
const isDesktop = useScreenSize();
const isScreenSize = useScreenSize();
const onShow = () => {
    if (isScreenSize.screenSize.value === 'xs') {
        isMobile.value = true;
        document.body.classList.add('no-scroll');
    }
};
const onHide = () => {
    if (isScreenSize.screenSize.value === 'xs') {
        isMobile.value = false;
        document.body.classList.remove('no-scroll');
    }
};

// Define props
const props = defineProps({
    zIndex: {
        type: String,
        default: '',
    },
    listId: {
        type: String,
    },
    title: {
        type: String,
    },
    icons: {
        type: String,
    },
    gray: {
        type: Boolean,
        default: false,
    },
    selfStop: {
        type: Boolean,
        default: false,
    },
    btnClass: {
        type: String,
        default: '',
    },
    ulClass: {
        type: String,
        default: '',
    },
    place: {
        type: String,
        default: 'auto',
    },
    popperClass: {
        type: String,
        default: '',
    },
    dropdowntheme: {
        type: String,
        default: 'appDropdownList',
    },
    distance: {
        type: Number,
        default: 0,
    },
});

// Define emits
const emit = defineEmits(['listClick', 'openAlert']);

const popperButton = ref(null);

const openAlert = () => {
    emit('openAlert', popperButton);
};
</script>

<style scoped>
.v-popper--theme-appDropdownList .v-popper__inner li,
.v-popper--theme-stepperDropdown .v-popper__inner li {
    padding: 16px;
}
</style>
